import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Topbar from "../Topbar/Topbar";
import { FaStarOfLife } from "react-icons/fa6";
import { Modal, Box, Button } from "@mui/material";
import { ImCross } from "react-icons/im";
import { FiX, FiUpload } from "react-icons/fi"; // Close & Upload icons
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./Add_installation.css";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useRef } from "react";
import _, { assign } from "lodash";
import dayjs from "dayjs";
import { MdEdit } from "react-icons/md";
import { FaUserEdit } from "react-icons/fa";

import MessageBox from "../MessageBox/MessageBox";

export default function Add_Installation() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const staffName = useSelector((state) => state.staffname);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messageData, setMessageData] = useState(null);
  const [routerMaterial, setRouterMaterial] = useState([]);
  const permissions = useSelector((state) => state.permissions);

  const [searchText, setSearchText] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [enquiryId, setEnquiryId] = useState(null); // Add this to your component
  const [pageRefId, setpageRefId] = useState("");
  const Id = useSelector((state) => state.id);

  const [customerData, setCustomerData] = useState(null);
  const [error, setError] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [approvePersons, setApprovePersons] = useState([]); // Array of selected persons
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const approveDropdownRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedNames, setSelectedNames] = useState([]);
  const dropdownRef = useRef(null);
  const [names, setNames] = useState([]);
  const [ottData, setOttData] = useState([]);

  const filteredNames = names.filter((staff) =>
    staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const currentTime = dayjs().format("hh:mm A"); // Example: "11:42:00 AM"
  const formatDate = (date) => {
    return dayjs(date).format("DD-MM-YYYY");
  };

  const [isOpenAssign, setIsOpenAssign] = useState(false);

  const [rows, setRows] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEditable, setIsEditable] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false); // to track update mode
  const [originalComplaint, setOriginalComplaint] = useState(null);

  const [addInstall, setAddInstall] = useState({
    leadId: "",

    createdDate: "",
    leadStatus: "open",
    installcustomerName: "",
    installcontactNum: "",
    installalternateNum: "",
    installaddress: "",
    location: "",
    installleadSource: "",
    installemailId: "",
    installsalesName: {
      staffName: "",
      _id: "",
    },
    installplanDetails: {
      installplanSpeed: "",
      installplanMonth: "",
      installplanAmount: "",
      installstaticIpCost: "",
      installfiberCableMeter: "",
      installinstalationCost: "",
      installrouterModel: "",
      enquiryrouterCost: "",
      routerSellingCost: "",
      enquiryfiberCost: "",
      installrouterCost: "",
      installottPackDetails: "",
      installottPrice: [],
      installothers: "",
      installothersCost: "",
      installadvanceAmount: {
        installcurrentDate: "",
        installamount: "",
        installpaymentType: "",
        installreferenceNumber: "",
      },

      installadvanceAmountPay: "",
    },
    installnextFollowUpDate: "",

    installleadStatus: {
      installnotes: "",
      installLeadStatusnextFollowUpDate: "",
    },

    verification: {
      verificationStatus: "",
      nextFollowUpDate: "",
      notes: "",
      verificationImage: "",
      updatedBy: "",
      updatedTime: "",
      updatedDate: "",
    },
    workAssign: {
      fiberTeam: [
        {
          materialRequire: "",
          materilType: "",
          unit: "",
          updatedBy: "",
          updatedTime: "",
          updatedDate: "",
        },
      ],

      networkTeam: [
        {
          materialRequire: "",
          materilType: "",
          unit: "",
          updatedBy: "",
          updatedTime: "",
          updatedDate: "",
        },
      ],
    },

    feedback: {
      notes: "",
      updatedBy: "",
      updatedTime: "",
      updatedDate: "",
      customerId: ""
    },
    //  payment:[{
    // //   payType:"",
    // //   payAmount:"",
    // //   referenceNumber:"",
    // //   paymentImage:"",
    // //   updatedBy:"",
    // //   updatedTime:"",
    // //  updatedDate:""

    // }],
  });

  const [taskData, setTaskData] = useState({
    taskName: "Installation",
    assignedBy: staffName,
    assignDateTime: "",
    // taskType: 'Once',
    taskPriority: "Low",
    deadline: "",
    time: "",
    assignedTo: [{}], // Array for multiple selections
    approvePerson: "",
    description: "",
    name: addInstall.installcustomerName || "",
    leadId: addInstall.leadId || "",
    taskStatus: "Open",
  });

  const [selectedFile, setSelectedFile] = useState(null);

  const [isOpenAdvancePayment, setIsOpenAdvancePayment] = useState(false);

  // Handle file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const [isOpenplan, setIsOpenplan] = useState(false);
  const [isOpenConverted, setIsOpenConverted] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const now = new Date();

    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const yyyy = now.getFullYear();

    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 becomes 12
    const hh = String(hours).padStart(2, "0");

    const formattedDateTime = `${dd}-${mm}-${yyyy} / ${hh}:${minutes} ${ampm}`;

    setTaskData((prev) => ({
      ...prev,
      assignDateTime: formattedDateTime,
    }));
  }, []);

  // Close dropdown when clicking outside

  useEffect(() => {
    fetch(apiUrl + "generate-lead-id")
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched Lead ID:", data.leadId); // Debugging log

        setAddInstall((prev) => ({
          ...prev, // Spread previous state
          leadId: data.leadId, // Update only the leadId field
          createdDate: new Date().toISOString().split("T")[0], // Set today's date
        }));
      })
      .catch((error) => console.error("Error fetching Lead ID:", error));
  }, []);

  const handlePlanChange = (e) => {
    const { name, value } = e.target;

    const convertCurrencyStringToNumber = (str) => {
      const cleaned = str.replace(/[₹,]/g, "");
      return parseFloat(cleaned);
    };

    // ✅ Handle Router selection
    if (name === "installrouterModel") {
      const selectedRouter = routerMaterial.find(
        (r) => r.materialType === value
      );
      const routerCost = selectedRouter ? selectedRouter.sellingCost : 0;

      setAddInstall((prev) => ({
        ...prev,
        installplanDetails: {
          ...prev.installplanDetails,
          installrouterModel: value,
          installrouterCost: routerCost,
          routerSellingCost: routerCost
        },
      }));
      return;
    }

    // ✅ Handle OTT Pack selection
    if (name === "installottPackDetails") {
      const selectedOtt = ottData.find((ott) => ott.ottDetail === value);
      const ottPrice = selectedOtt
        ? convertCurrencyStringToNumber(selectedOtt.ottPrice)
        : 0;

      setAddInstall((prev) => ({
        ...prev,
        installplanDetails: {
          ...prev.installplanDetails,
          installottPackDetails: value,
          installottPrice: [ottPrice], // store as array
        },
      }));
      return;
    }

    // ✅ For all other fields
    setAddInstall((prev) => ({
      ...prev,
      installplanDetails: {
        ...prev.installplanDetails,
        [name]: value,
      },
    }));
  };



  //   function formatDate(inputDate) {
  //   if (!inputDate) return "";

  //   const [year, month, day] = inputDate.split("-");
  //   return `${day}-${month}-${year}`;
  // }

  // Example:

  useEffect(() => {
    axios.get(apiUrl + "/router-selling/all", {}).then((res) => {
      const add_installation = res.data || [];
      console.log("Fetched data:", add_installation); // ✅ Check this output

      setRouterMaterial(add_installation);
    });
  }, []);

  useEffect(() => {
    axios.get(apiUrl + "/get_fibermetersellingcost").then((res) => {
      const data = res.data;
      const fiberData = Array.isArray(data) && data.length > 0 ? data[0] : null;

      setAddInstall((prev) => ({
        ...prev,
        installplanDetails: {
          ...prev.installplanDetails,
          installfiberCost: fiberData?.fibermetersellingcost || 0,
        },
      }));
    });
  }, []);

  const handleAmountChange = (e) => {
    const { name, value } = e.target;
    setAddInstall((prevState) => ({
      ...prevState,
      installplanDetails: {
        ...prevState.installplanDetails,
        installadvanceAmount: {
          ...prevState.installplanDetails.installadvanceAmount,
          [name]: value,
        },
      },
    }));
  };

  const handleLeadChange = (e) => {
    const { name, value } = e.target;
    setAddInstall((prevState) => ({
      ...prevState,
      installleadStatus: {
        ...prevState.installleadStatus,
        [name]: value,
      },
    }));
  };

  const convertStringToObject = (locationString) => {
    // Split the input string by a comma and trim whitespace
    const [latitude, longitude] = locationString
      .split(",")
      .map((value) => value.trim());

    // Return the object with parsed latitude and longitude
    return {
      latitude: parseFloat(latitude),
      longitude: parseFloat(longitude),
    };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name in addInstall.installleadStatus) {
      // For nested installleadStatus fields
      setAddInstall((prevState) => ({
        ...prevState,
        installleadStatus: {
          ...prevState.installleadStatus,
          [name]: value,
        },
      }));
    } else if (name === "installadvanceAmountPay") {
      // For nested installplanDetails.installadvanceAmountPay
      setAddInstall((prevState) => ({
        ...prevState,
        installplanDetails: {
          ...prevState.installplanDetails,
          installadvanceAmountPay: value,
        },
      }));
    } else {
      // For top-level fields
      setAddInstall((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  // const handleChange = (e) => {
  //   setAddInstall({ ...addInstall, [e.target.name]: e.target.value });
  // };
  const [errors, setErrors] = useState({}); // Validation errors

  const handleSubmit = async (e) => {
    e.preventDefault();

    //  let locationObject;
    //     try {
    //       locationObject = convertStringToObject(addInstall.location);
    //       if (
    //         isNaN(locationObject.latitude) ||
    //         isNaN(locationObject.longitude)
    //       ) {
    //         throw new Error("Invalid location format");
    //       }
    //     } catch (error) {
    //       Swal.fire(
    //         "Error",
    //         "Please enter a valid location in the format: 12.123456, 33.123456",
    //         "error"
    //       );
    //       return;
    //     }

    if (isEditMode) {
      // ✅ Check if there are any changes
      if (_.isEqual(addInstall, originalComplaint)) {
        Swal.fire("No Changes", "No changes were made to update.", "info");
        return;
      }
    }

    // ✅ Show confirmation only when changes exist
    const result = await Swal.fire({
      title: isEditMode ? "Update the changes?" : "Are you sure?",
      showCancelButton: true,
      confirmButtonText: isEditMode ? "Update" : "Submit",
    });

    if (result.isConfirmed) {
      const now = new Date();
      const date = now.toLocaleDateString();
      const time = now.toLocaleTimeString();
      try {
        if (isEditMode) {
          await axios.post(apiUrl + "/update-lead-install", addInstall, {
            headers: { "Content-Type": "application/json" },
          });
          Swal.fire("Updated!", "Data updated successfully", "success");
        } else {
          await axios
            .post(
              apiUrl + "add-lead-install",
              {
                ...addInstall,
                createdBy: {
                  staffName: staffName,
                  _id: Id,
                  time: time,
                  date: date,
                },
                installcustomerName: addInstall.installcustomerName,
                installcontactNum: addInstall.installcontactNum,
                installalternateNum: addInstall.installalternateNum,
                installaddress: addInstall.installaddress,
                location: addInstall.location
                  ? convertStringToObject(addInstall.location)
                  : {}, // <-- this goes inside the data object
              },
              { headers: { "Content-Type": "application/json" } }
            )
            .then((response) => {
              const savedId = response.data.data?._id;
              setEnquiryId(savedId);
              setpageRefId(savedId);

              const formData = new FormData();
              formData.append("pageRefId", savedId);
              formData.append("page", "Installation");
              formData.append("colorCode", "#fbdc6e");
              formData.append(
                "description",
                addInstall.installleadStatus?.installnotes || "No Description"
              );
              formData.append("staffPic", "");
              if (selectedFile) {
                formData.append("image", selectedFile);

              }
              formData.append("updatesHistory[staff][name]", staffName);
              formData.append("updatesHistory[staff][id]", Id);
              formData.append("updatesHistory[status]", addInstall.leadStatus || "Open");

              axios
                .post(apiUrl + "add-message", formData, {
                  headers: { "Content-Type": "multipart/form-data" },
                })
                .then(() => {
                  console.log("Project update sent.");

                  // ✅ Fetch messages after update
                  axios
                    .get(`${apiUrl}messages/${savedId}`)
                    .then((res) => {
                      setMessageData(res.data.data);
                      setShowMessageBox(true); // ✅ Only show message box here!
                    })
                    .catch((err) => {
                      console.error("Fetching messages failed:", err);
                    });

                  Swal.fire(
                    "Success!",
                    "Installation Details Added",
                    "success"
                  );
                  setIsSubmitted(true);
                  setIsEditable(false);
                  setIsEditMode(false);
                })

                .then(() => {
                  console.log("Project update sent.");

                  // ✅ Fetch messages immediately after successful project update
                  axios
                    .get(`${apiUrl}messages/${savedId}`)
                    .then((res) => {
                      setMessageData(res.data.data);
                      console.log("Fetched Messages:", res.data.data);
                    })
                    .catch((err) => {
                      console.error("Fetching messages failed:", err);
                    });

                  Swal.fire(
                    "Success!",
                    "Installation Details Added",
                    "success"
                  );
                  setIsSubmitted(true);
                  setIsEditable(false);
                  setIsEditMode(false);
                })
                .catch((err) => {
                  console.error("Project update error:", err);
                  Swal.fire(
                    "Warning",
                    "installation details saved, but project update failed.",
                    "warning"
                  );
                });
            });
          Swal.fire("Success!", "Installation Details Added", "success");
          setIsSubmitted(true);
        }

        setIsEditable(false);
        setIsEditMode(false);
      } catch (error) {
        Swal.fire(
          "Error",
          error.response?.data?.message || "Something went wrong!",
          "error"
        );
      }
    }
  };
  const handleInputChange = (field, value) => {
    if (field === "time") {
      const [hours, minutes] = value.split(":");
      let hh = parseInt(hours, 10);
      const ampm = hh >= 12 ? "PM" : "AM";
      hh = hh % 12 || 12;
      const formattedTime = `${hh
        .toString()
        .padStart(2, "0")}:${minutes} ${ampm}`;

      setTaskData((prev) => ({
        ...prev,
        time: formattedTime, // Store as "hh:mm AM/PM"
        timeRaw: value, // Optional: keep raw value like "17:17" if needed
      }));
    } else {
      setTaskData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };
  const handleSubmitAssignTask = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure you want to create this task?",
      showCancelButton: true,
      confirmButtonText: "Submit",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const now = new Date();
          const day = String(now.getDate()).padStart(2, "0");
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const year = now.getFullYear();
          const updatedDate = `${day}-${month}-${year}`;

          let hours = now.getHours();
          const minutes = String(now.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          const updatedTime = `${hours}:${minutes} ${ampm}`;

          const datas = {
            ...taskData,
            assignedBy: {
              staffName: staffName,
              id: Id,
            },
            updatedDate,
            updatedTime,
            assignedTo: selectedNames,
            approvePerson: approvePersons,
            collectionId: enquiryId,
          };

          // Required fields to check
          const requiredFields = [
            "taskName",
            "assignDateTime",
            // "taskPriority",
            // "taskType",
            "deadline",
            "assignedTo",
            "approvePerson",
            "description",
          ];

          // Check for empty fields
          const emptyFields = requiredFields.filter(
            (field) =>
              !datas[field] ||
              (Array.isArray(datas[field]) && datas[field].length === 0)
          );

          if (emptyFields.length > 0) {
            Swal.fire({
              icon: "warning",
              title: "Incomplete Data",
              text: `Please fill all the fields:`,
            });
            return;
          }

          const response = await axios.post(apiUrl + "add-assign-task", datas, {
            headers: { "Content-Type": "application/json" },
          });

          Swal.fire({
            title: "Task Created Successfully!",
            icon: "success",
          }).then(() => {
            navigate("/task");
          });
        } catch (error) {
          console.log(
            "Error submitting data:",
            error.response?.data || error.message
          );
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response?.data?.message || "Something went wrong!",
          });
        }
      }
    });
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  // Checkbox change handler expects a staffName string
  const handleCheckboxChange = (staff) => {
    setSelectedNames((prev) => {
      const exists = prev.find((item) => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter((item) => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };

  const displayText =
    selectedNames.length > 0
      ? selectedNames.map((item) => item.staffName).join(", ")
      : "Select names";

  useEffect(() => {
    const fetchCustomerData = () => {
      if (!customerId.trim()) {
        setCustomerData(null); // Clear data if ID is empty
        setError("");
        return;
      }

      axios
        .get(apiUrl + `customer/${customerId}`)
        .then((response) => {
          const fetchedData = response.data;
          setCustomerData(fetchedData);

          setAddInstall((prev) => ({
            ...prev,
            installcustomerName: fetchedData.customername,
            installcontactNum: fetchedData.contactnum,
            installaddress: fetchedData.installationadd,
            installplanDetails: {
              ...prev.installplanDetails,
              installplanMonth: fetchedData.planname,
            },
          }));

          setError("");
        })
        .catch((err) => {
          if (err.response?.status === 404) {
            setError("Customer not found");
          } else {
            setError("An error occurred. Please try again later.");
          }
          setCustomerData(null);
        });
    };

    fetchCustomerData();
  }, [customerId]);

  const toggleApproveDropdown = () => {
    setIsApproveOpen((prev) => !prev);
  };

  const handleApproveCheckboxChange = (staff) => {
    setApprovePersons((prev) => {
      const exists = prev.find((item) => item._id === staff._id);
      if (exists) {
        // Remove staff
        return prev.filter((item) => item._id !== staff._id);
      } else {
        // Add staff
        return [...prev, staff];
      }
    });
  };
  const approvePersonText =
    approvePersons.length > 0
      ? approvePersons.map((item) => item.staffName).join(", ")
      : "Select Approve Persons";

  useEffect(() => {
    axios.post(apiUrl + "viewott", {}).then((res) => {
      const add_installation = res.data.message || [];
      console.log("Fetched data:", add_installation); // ✅ Check this output

      setOttData(add_installation);
    });
  }, []);

  const listView = () => {
    axios
      .post(apiUrl + "viewlead", {})
      .then((res) => {
        setRows(res.data.message);
      })
      .catch((error) => {
        console.error("Error fetching data", error);
      });
  };

  useEffect(() => {
    listView();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (
        approveDropdownRef.current &&
        !approveDropdownRef.current.contains(event.target)
      ) {
        setIsApproveOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    axios
      .get(apiUrl + "get-staff-names")
      .then((res) => {
        if (res.data.message) {
          setNames(res.data.message); // names = array of objects like { _id, staffName }
        }
      })
      .catch((err) => {
        console.log("Error fetching staff names:", err);
      });

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  console.log(addInstall);

  return (
    <>
      <Topbar />
      <Container className="mt-1    ">
        <form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <h3>Installation</h3>
            </Col>

            <Col className="mx-5 text-end">
              {/* Initial Submit */}
              {/* Initial Submit (Add mode) */}
              {!isSubmitted && !isEditMode && (
                <button
                  className="blue-btn px-4 text-white"
                  value="submit"
                  type="submit"
                >
                  Submit
                </button>
              )}

              {/* After Submit (Edit & Assign buttons) */}
              {isSubmitted && !isEditable && (
                <>
                  <button
                    className="black-btn me-2"
                    type="button"
                    onClick={() => {
                      // Store a deep copy of current form data before editing
                      setOriginalComplaint(
                        JSON.parse(JSON.stringify(addInstall))
                      );
                      setIsEditable(true);
                      setIsEditMode(true);
                    }}
                  >
                    <MdEdit size={18} /> Edit
                  </button>
                  {/* 
                  
        {permissions?.Installation?.["Installation Task Assign"]?.Read && (
                  <button className=" blue-btn" type="button" onClick={() => {
                    setTaskData((prev) => ({
                      ...prev,
                      name: addInstall.installcustomerName || '',
                      leadId: addInstall.leadId || '',
                    }))
                    setIsOpenAssign(true)
                  }}>
                    <FaUserEdit size={18} /> Assign 
                  </button>

                )} */}

                  {isOpenAssign && (
                    <div className="overlay3">
                      <div className="modal3">
                        <Container>
                          <div className=" text-end mx-2">
                            <button
                              type="button"
                              className="black-btn mx-3"
                              onClick={() => setIsOpenAssign(false)}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className=" blue-btn mx-3"
                              onClick={handleSubmitAssignTask}
                            >
                              Submit
                            </button>
                          </div>

                          <Row className="mt-4">
                            <Col xs={12} md={6}>
                              <Row>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Task Name</lable>
                                  <br />
                                  <input
                                    type="text"
                                    className="form-input"
                                    readOnly
                                    value={taskData.taskName}
                                  />
                                </Col>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Assign Date/Time</lable>
                                  <br />
                                  <input
                                    type="datetime-local"
                                    value={taskData.assignDateTime}
                                    required
                                    className="form-input"
                                    onChange={(e) =>
                                      handleInputChange(
                                        "assignDateTime",
                                        e.target.value
                                      )
                                    }
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>
                                {/* <Col xs={12} md={6} className="text-start">
                                                    <lable>Task Type</lable>
                  
                                                    <br />
                                                    <select
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          "taskType",
                                                          e.target.value
                                                        )
                                                      }
                                                      class="dropbtn form-input-select overlay2"
                                                    >
                                                      <option value="Once">Once</option>
                                                      <option value="Daily">Daily</option>
                                                      <option value="weekly">Weekly</option>
                                                      <option value="Monthy">Monthly</option>
                                                      <option value="Custom">Custom</option>
                                                    </select>
                                                  </Col> */}

                                <Col xs={12} md={6} className="text-start">
                                  <lable>Task Priority </lable>
                                  <br />
                                  <select
                                    onChange={(e) =>
                                      handleInputChange(
                                        "taskPriority",
                                        e.target.value
                                      )
                                    }
                                    class="dropbtn form-input-select overlay2"
                                  >
                                    <option value="Low">Low</option>
                                    <option value="High">High</option>
                                    <option value="Immediate">Immediate</option>
                                  </select>
                                </Col>

                                <Col xs={12} md={6} className="text-start">
                                  <lable>Deadline Date/Time</lable>
                                  <br />
                                  <input
                                    type="datetime-local"
                                    onChange={(e) =>
                                      handleInputChange(
                                        "deadline",
                                        e.target.value
                                      )
                                    }
                                    className="form-input overlay2"
                                    placeholder=""
                                    min={new Date().toISOString().split("T")[0]} // only allows today or future
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} md={6}>
                              <Row>
                                {/* <Col xs={12} md={6} className="text-start">
                                                    <lable>Deadline Time</lable>
                                                    <br />
                                                    <input
                                                      type="time"
                                                      onChange={(e) =>
                                                        handleInputChange("time", e.target.value)
                                                      }
                                                      className="form-input overlay2"
                                                      placeholder=""
                                                    />
                                                  </Col> */}
                              </Row>
                            </Col>
                            <Col>
                              <Row>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Task Asign To</lable>
                                  <br />
                                  <div
                                    ref={dropdownRef}
                                    style={{
                                      position: "relative",
                                      width: "85%",
                                    }}
                                  >
                                    <div
                                      onClick={toggleDropdown}
                                      style={{
                                        padding: "10px",
                                        border: "2px solid #a7a7a7",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        backgroundColor: "#fff",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {displayText}
                                      </span>
                                      <span>{isOpen ? "▲" : "▼"}</span>
                                    </div>

                                    {isOpen && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "100%",
                                          left: 0,
                                          right: 0,
                                          marginTop: "5px",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                          backgroundColor: "#fff",
                                          boxShadow:
                                            "0 2px 5px rgba(0,0,0,0.2)",
                                          zIndex: 1000,
                                          maxHeight: "250px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {/* 🔍 Search Input */}
                                        <input
                                          type="text"
                                          placeholder="Search staff..."
                                          value={searchText}
                                          onChange={(e) =>
                                            setSearchText(e.target.value)
                                          }
                                          style={{
                                            width: "95%",
                                            margin: "10px auto",
                                            display: "block",
                                            padding: "8px",
                                            borderRadius: "4px",
                                            border: "1px solid #ccc",
                                          }}
                                        />

                                        {/* Filtered Staff List */}
                                        {names.filter((staff) =>
                                          staff.staffName
                                            .toLowerCase()
                                            .includes(searchText.toLowerCase())
                                        ).length === 0 ? (
                                          <div
                                            style={{
                                              padding: "10px",
                                              color: "#888",
                                              textAlign: "center",
                                            }}
                                          >
                                            No Staffs found
                                          </div>
                                        ) : (
                                          names
                                            .filter((staff) =>
                                              staff.staffName
                                                .toLowerCase()
                                                .includes(
                                                  searchText.toLowerCase()
                                                )
                                            )
                                            .map((staff) => (
                                              <label
                                                key={staff._id}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  padding: "10px",
                                                  cursor: "pointer",
                                                  borderBottom:
                                                    "1px solid #eee",
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  checked={selectedNames.some(
                                                    (item) =>
                                                      item._id === staff._id
                                                  )}
                                                  onChange={() =>
                                                    handleCheckboxChange(staff)
                                                  }
                                                  style={{
                                                    marginRight: "10px",
                                                  }}
                                                  required
                                                />
                                                {staff.staffName}
                                              </label>
                                            ))
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </Col>

                                <Col xs={12} md={6} className="text-start">
                                  <lable>Approve Person </lable>
                                  <br />
                                  <div
                                    ref={approveDropdownRef}
                                    style={{
                                      position: "relative",
                                      width: "85%",
                                      marginTop: "15px",
                                    }}
                                  >
                                    <div
                                      onClick={toggleApproveDropdown}
                                      style={{
                                        padding: "10px",
                                        border: "2px solid #a7a7a7",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        backgroundColor: "#fff",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: "-5px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {approvePersonText}
                                      </span>
                                      <span>{isApproveOpen ? "▲" : "▼"}</span>
                                    </div>

                                    {isApproveOpen && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "100%",
                                          left: 0,
                                          right: 0,
                                          marginTop: "5px",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                          backgroundColor: "#fff",
                                          boxShadow:
                                            "0 2px 5px rgba(0,0,0,0.2)",
                                          zIndex: 1000,
                                          maxHeight: "250px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {/* 🔍 Search Input */}
                                        <input
                                          type="text"
                                          placeholder="Search staff..."
                                          value={searchTerm}
                                          onChange={(e) =>
                                            setSearchTerm(e.target.value)
                                          }
                                          style={{
                                            width: "100%",
                                            padding: "8px 10px",
                                            borderBottom: "1px solid #ccc",
                                            boxSizing: "border-box",
                                            outline: "none",
                                            border: "none",
                                          }}
                                        />

                                        {/* 🧑‍💼 Filtered Staff List */}
                                        {filteredNames.length === 0 ? (
                                          <div
                                            style={{
                                              padding: "10px",
                                              color: "#888",
                                              textAlign: "center",
                                            }}
                                          >
                                            No staff found
                                          </div>
                                        ) : (
                                          filteredNames.map((staff) => (
                                            <label
                                              key={staff._id}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "10px",
                                                cursor: "pointer",
                                                borderBottom: "1px solid #eee",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                required
                                                checked={approvePersons.some(
                                                  (item) =>
                                                    item._id === staff._id
                                                )}
                                                onChange={() =>
                                                  handleApproveCheckboxChange(
                                                    staff
                                                  )
                                                }
                                                style={{ marginRight: "10px" }}
                                              />
                                              {staff.staffName}
                                            </label>
                                          ))
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} md={6} className="text-start">
                              <lable>Description</lable>
                              <br />
                              <textarea
                                type="text"
                                onChange={(e) =>
                                  handleInputChange(
                                    "description",
                                    e.target.value
                                  )
                                }
                                style={{
                                  textTransform: "capitalize",
                                  resize: "none",
                                }}
                                className="form-input inputfield-assign "
                                placeholder="Enter Notes "
                              />
                            </Col>
                            <Col>
                              <Row>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Lead ID</lable>
                                  <br />
                                  <input
                                    type="text"
                                    value={taskData.leadId}
                                    className="form-input overlay2"
                                    readOnly
                                  />
                                </Col>

                                <Col xs={12} md={6} className="text-start">
                                  <lable>Name </lable>
                                  <br />
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleInputChange("name", e.target.value)
                                    }
                                    style={{ textTransform: "capitalize" }}
                                    className="form-input "
                                    placeholder="Enter Notes "
                                    readOnly
                                    value={taskData.name}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={12} md={6} className="text-start">
                                  <lable>Task Status </lable>
                                  <br />
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      handleInputChange(
                                        "taskStatus",
                                        e.target.value
                                      )
                                    }
                                    // style={{ textTransform: "capitalize" }}
                                    style={{
                                      backgroundColor: "#fbdc6e",
                                      color: "rgb(94, 94, 14)",
                                      textTransform: "capitalize",
                                    }}
                                    className="form-input "
                                    readonly
                                    value={taskData.taskStatus}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Container>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Update Submit (Edit mode) */}
              {isEditMode && isEditable && (
                <>
                  <button className=" blue-btn" value="submit" type="submit">
                    Submit
                  </button>

                  <button
                    className="black-btn ms-2"
                    type="button"
                    onClick={() => {
                      // Reset to the original values
                      setAddInstall(
                        JSON.parse(JSON.stringify(originalComplaint))
                      );
                      setIsEditable(false);
                      setIsEditMode(false);
                    }}
                    disabled={!isEditable} // Disable cancel button when not in edit mode
                  >
                    Cancel
                  </button>
                </>
              )}
            </Col>
          </Row>

          <div className="border-container1">
            <h6 className="form-head  m-0 text-white  ">Order Details</h6>
          </div>

          <div className="border-container ">
            <Row className="text-start lead-id-row  mb-4 mt-4 ms-4 ">
              <p className="ps-5 paragraph-lead-id">
                Lead ID -{" "}
                <span
                  className="text-primary "
                  value={addInstall.leadId}
                  onChange={handleChange}
                >
                  {addInstall.leadId}
                </span>{" "}
                <span className="lead-start-date">
                  {" "}
                  Lead Started Date -{" "}
                  <span className="text-primary">{formatDate(addInstall.createdDate)}</span>
                </span>{" "}
              </p>
            </Row>
            <Row className="ms-3">
              <Col md={6} sm={12}>
                <Row>
                  {/* <Col xs={12} md={6} className="text-start">
                    <label>Customer Id *</label>
                    <br />
                    <input
                      type="text"
                      name="customerid"
                      className="form-input"
                      placeholder="Enter Customer Id"
                      value={customerId}
                      disabled={!isEditable}
                      onChange={(e) => {
                        setCustomerId(e.target.value); // Update the state
                        handleChange(e);
                        // Trigger the recovery handler
                      }}
                    />
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </Col> */}

                  <Col sm={12} md={12} className="text-start ">
                    <lable>Customer Name</lable>
                    <br />
                    <input
                      type="text"
                      style={{ textTransform: "capitalize " }}
                      className="form-input "
                      placeholder="Enter Custmer Name"
                      value={addInstall.installcustomerName}
                      onChange={handleChange}
                      name="installcustomerName"

                      disabled={!isEditable}
                    />
                  </Col>
                </Row>
              </Col>

              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>
                      Contact Number
                      <sup>
                        <FaStarOfLife size={7} />
                      </sup>
                    </lable>
                    <br />
                    <input
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Enter Phone Number"
                      className="form-input"
                      value={addInstall.installcontactNum}
                      onChange={handleChange}
                      name="installcontactNum"
                      maxLength={10}

                      required
                      disabled={!isEditable}
                    />
                  </Col>

                  <Col xs={12} md={6} className="text-start">
                    <lable>Alternate Number </lable>
                    <br />
                    <input
                      type="tel"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      value={addInstall.installalternateNum}
                      onChange={handleChange}
                      name="installalternateNum"
                      maxLength={10}
                      className="form-input"
                      placeholder="Enter Phone Number"
                      disabled={!isEditable}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start">
                <lable> Address</lable>
                <br />
                <textarea
                  type="text"
                  value={addInstall.installaddress}
                  onChange={handleChange}
                  style={{ textTransform: "capitalize", resize: "none" }}
                  className=" box address-install"
                  placeholder="Enter  Address"
                  disabled={!isEditable}
                  name="installaddress"

                />
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Location</lable>
                    <br />
                    <input
                      value={addInstall.location}
                      onChange={handleChange}
                      style={{ textTransform: "capitalize" }}
                      className="form-input"
                      type="text"
                      placeholder="Enter Location"
                      name="location"
                      disabled={!isEditable}
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Lead Source</lable>
                    <br />

                    <select
                      value={addInstall.installleadSource}
                      onChange={handleChange}
                      class="dropbtn form-input-select"
                      name="installleadSource"
                      disabled={!isEditable}
                    >
                      <option value="">Select</option>
                      {rows.map((data, i) => {
                        return <option>{data.leadSource}</option>;
                      })}
                    </select>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <label>Sales Name</label>
                    <br />

                    <select
                      disabled={!isEditable}
                      value={addInstall.installsalesName._id}
                      onChange={(e) => {
                        const selected = names.find(
                          (staff) => staff._id === e.target.value
                        );
                        if (selected) {
                          setAddInstall((prev) => ({
                            ...prev,
                            installsalesName: {
                              _id: selected._id,
                              staffName: selected.staffName?.trim() || "",
                            },
                          }));
                        } else {
                          // Clear if no match
                          setAddInstall((prev) => ({
                            ...prev,
                            installsalesName: {
                              _id: "",
                              staffName: "",
                            },
                          }));
                        }
                      }}
                      name="installsalesName"
                      className="dropbtn form-input-select"
                    >
                      <option value="">Select</option>
                      {names.map((staff) => (
                        <option key={staff._id} value={staff._id}>
                          {staff.staffName?.trim()}
                        </option>
                      ))}
                    </select>
                  </Col>

                  <Col xs={12} md={6} className="text-start">
                    <label></label>
                    <input
                      type="button"
                      value="Plan details"
                      onClick={() => setIsOpenplan(true)}
                      className="form-input converted-form plandetails-form "
                      onChange={handleChange}
                      disabled={!isEditable}
                    />

                    {isOpenplan && (
                      <div className="overlay1">
                        <div className="modal1">
                          <Container>
                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Speed</lable>
                                    <br />
                                    <input
                                      type="text"
                                      value={
                                        addInstall.installplanDetails
                                          .installplanSpeed
                                      }
                                      onChange={handlePlanChange}
                                      name="installplanSpeed"
                                      className="form-input overlay2"
                                      placeholder="Enter Plan Speed"
                                    />
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Month</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addInstall.installplanDetails
                                          .installplanMonth
                                      }
                                      onChange={handlePlanChange}
                                      name="installplanMonth"
                                      className="form-input overlay2"
                                      placeholder="Enter Plan Month"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Amount</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addInstall.installplanDetails
                                          .installplanAmount
                                      }
                                      onChange={handlePlanChange}
                                      name="installplanAmount"
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Static Ip Cost </lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addInstall.installplanDetails
                                          .installstaticIpCost
                                      }
                                      onChange={handlePlanChange}
                                      name="installstaticIpCost"
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Fiber Cable Meter</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addInstall.installplanDetails
                                          .installfiberCableMeter
                                      }
                                      onChange={handlePlanChange}
                                      name="installfiberCableMeter"
                                      className="form-input overlay2"
                                      placeholder="Enter Meter"
                                    />
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Installation Cost</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addInstall.installplanDetails
                                          .installinstalationCost
                                      }
                                      onChange={handlePlanChange}
                                      name="installinstalationCost"
                                      className="form-input overlay2"
                                      placeholder="Enter installation Cost"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <label>Router Model</label>
                                    <br />
                                    <select
                                      value={
                                        addInstall.installplanDetails
                                          .installrouterModel || ""
                                      }
                                      onChange={handlePlanChange}
                                      name="installrouterModel"
                                      className="dropbtn form-input-select overlay2" // ✅ fixed `className`
                                    >
                                      <option value="">Select</option>
                                      {routerMaterial.map((item) => (
                                        <option
                                          key={item._id}
                                          value={item.materialType}
                                        >
                                          {item.materialType}
                                        </option>
                                      ))}
                                    </select>
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Router Cost </lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addInstall.installplanDetails
                                          .installrouterCost
                                      }
                                      onChange={handlePlanChange}
                                      name="installrouterCost"
                                      className="form-input overlay2"
                                      placeholder="Enter installation Cost"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>OTT Pack Details</lable>
                                    <br />
                                    <select
                                      value={
                                        addInstall.installplanDetails
                                          .installottPackDetails
                                      }
                                      onChange={handlePlanChange}
                                      name="installottPackDetails"
                                      className="dropbtn form-input-select overlay2"
                                    >
                                      <option value="">Select</option>

                                      {ottData.map((ott) => (
                                        <option
                                          key={ott._id}
                                          value={ott.ottDetail}
                                        >
                                          {ott.ottDetail}
                                        </option>
                                      ))}
                                    </select>
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Others</lable>
                                    <br />
                                    <input
                                      type="text"
                                      value={
                                        addInstall.installplanDetails
                                          .installothers
                                      }
                                      onChange={handlePlanChange}
                                      name="installothers"
                                      style={{ textTransform: "capitalize" }}
                                      className="form-input overlay2"
                                      placeholder="Enter "
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Others Cost</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      value={
                                        addInstall.installplanDetails
                                          .installothersCost
                                      }
                                      onChange={handlePlanChange}
                                      name="installothersCost"
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Advance Amount </lable>
                                    <br />

                                    <select
                                      className="form-input-select"
                                      name="installadvanceAmountPay"
                                      value={
                                        addInstall.installplanDetails
                                          .installadvanceAmountPay || ""
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                        if (e.target.value === "Pay") {
                                          setIsOpenAdvancePayment(true);
                                        }
                                      }}
                                    >
                                      <option value="">Select Type</option>
                                      <option value="Unpay">Unpay</option>
                                      <option value="Pay">Pay</option>
                                    </select>

                                    {isOpenAdvancePayment && (
                                      <div className="overlay-advance-payment">
                                        <div className="modal-advance-payment">
                                          <Container>
                                            <Row>
                                              <Col>
                                                {" "}
                                                <h6>Advance Pay</h6>
                                              </Col>
                                              <Col className="text-end">
                                                <span
                                                  style={{
                                                    fontSize: "23px",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    setIsOpenAdvancePayment(
                                                      false
                                                    )
                                                  }
                                                >
                                                  <strong>&times;</strong>
                                                </span>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col>
                                                <div>
                                                  <label>Current Date</label>
                                                  <br />
                                                  <input
                                                    className="form-input"
                                                    type="date"
                                                    value={
                                                      addInstall
                                                        .installplanDetails
                                                        .installadvanceAmount
                                                        .installcurrentDate
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                    name="installcurrentDate"
                                                  />
                                                </div>
                                              </Col>
                                              <Col>
                                                <div>
                                                  <label>Payment Type</label>
                                                  <br />
                                                  <select
                                                    className="form-input-select"
                                                    value={
                                                      addInstall
                                                        .installplanDetails
                                                        .installadvanceAmount
                                                        .installpaymentType ||
                                                      ""
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                    name="installpaymentType"
                                                  >
                                                    <option value="">
                                                      Select Type
                                                    </option>
                                                    <option value="Private">
                                                      Private
                                                    </option>
                                                    <option value="Technology">
                                                      Technology
                                                    </option>
                                                    <option value="Cash">
                                                      Cash
                                                    </option>
                                                    <option value="Helpdesk">
                                                      Helpdesk
                                                    </option>
                                                    <option value="Others">
                                                      Others
                                                    </option>
                                                  </select>
                                                </div>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col>
                                                <div>
                                                  <label>Amount</label>
                                                  <br />
                                                  <input
                                                    className="form-input"
                                                    placeholder="Rs"
                                                    value={
                                                      addInstall
                                                        .installplanDetails
                                                        .installadvanceAmount
                                                        .installamount
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                    name="installamount"
                                                  />
                                                </div>
                                              </Col>
                                              <Col>
                                                <div>
                                                  <label>
                                                    Reference Number
                                                  </label>
                                                  <br />
                                                  <input
                                                    className="form-input"
                                                    placeholder="Enter Reference Number"
                                                    value={
                                                      addInstall
                                                        .installplanDetails
                                                        .installadvanceAmount
                                                        .installreferenceNumber
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                    name="installreferenceNumber"
                                                  />
                                                </div>
                                              </Col>
                                            </Row>

                                            <Row className="text-end mt-5">
                                              <Col className="text-start">
                                                <button
                                                  className="black-btn "
                                                  onClick={() =>
                                                    setIsOpenAdvancePayment(
                                                      false
                                                    )
                                                  }
                                                >
                                                  Cancel
                                                </button>
                                              </Col>
                                              <Col className="text-end">
                                                <button
                                                  className="blue-btn ms-5"
                                                  onClick={() =>
                                                    setIsOpenAdvancePayment(
                                                      false
                                                    )
                                                  }
                                                >
                                                  Submit
                                                </button>
                                              </Col>
                                            </Row>
                                          </Container>
                                        </div>
                                      </div>
                                    )}

                                    {/* </select> */}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <div className="button-group1">
                              <button
                                type="button"
                                className="black-btn"
                                onClick={() => setIsOpenplan(false)}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="ok-btn1"
                                onClick={() => setIsOpenplan(false)}
                              >
                                OK
                              </button>
                            </div>
                          </Container>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start">
                <lable>Mail ID</lable>
                <br />
                <input
                  value={addInstall.installemailId}
                  onChange={handleChange}
                  type="email"
                  placeholder="Enter Email ID"
                  className="form-input "
                  name="installemailId"
                  disabled={!isEditable}
                />
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Next Follow Up Date</lable>
                    <br />
                    <input
                      className="field form-input"
                      value={
                        addInstall.installleadStatus
                          .installLeadStatusnextFollowUpDate
                      }
                      onChange={handleChange}
                      readOnly
                      type="date"
                      name="installnextFollowUpDate"
                      disabled={!isEditable}
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Lead Status</lable>
                    <br />
                    <input
                      style={{
                        backgroundColor: "#fbdc6e",
                        color: "rgb(94, 94, 14)",
                      }}
                      type="button"
                      onClick={() => setIsOpenConverted(true)}
                      className="form-input converted-form"
                      name="installleadStatus"
                      value="Open"
                      disabled={!isEditable}
                    />

                    {isOpenConverted && (
                      <div className="overlay1-converted">
                        <div className="modal1-converted">
                          <Container>
                            <button
                              className="close-btn1"
                              onClick={() => setIsOpenConverted(false)}
                            >
                              <span style={{ fontSize: "20px" }}>
                                {" "}
                                &times;{" "}
                              </span>
                            </button>

                            <div className="open-button border">
                              <h5>Open</h5>
                            </div>

                            <textarea
                              style={{
                                textTransform: "capitalize",
                                resize: "none",
                              }}
                              placeholder="Enter Notes"
                              className="converted-textbox"
                              name="installnotes"
                              onChange={handleLeadChange}
                              value={addInstall.installleadStatus.installnotes}
                            />
                            <div className="upload-section">
                              <label className="upload-btn">
                                <FiUpload className="upload-icon" />
                                Upload Image
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                  hidden
                                />
                              </label>
                              {selectedFile && (
                                <p className="file-name">{selectedFile.name}</p>
                              )}
                            </div>

                            <Row>
                              <Col className="date-update-textbox">
                                <label>Next Follow Up Date</label>
                                <br />
                                <input
                                  type="date"
                                  className="field form-input"
                                  value={
                                    addInstall.installleadStatus
                                      .installLeadStatusnextFollowUpDate
                                  }
                                  onChange={handleLeadChange}
                                  name="installLeadStatusnextFollowUpDate"
                                />
                              </Col>
                              <Col className="uploadbtn-install">
                                <button
                                  type="button"
                                  className="blue-btn"
                                  onClick={() => setIsOpenConverted(false)}
                                >
                                  Upload
                                </button>
                              </Col>
                            </Row>
                          </Container>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </form>

        {showMessageBox && (
          <Row className="container ms-3  me-5">
            <Col md={6} sm={12}>
              <div>
                {messageData &&
                  messageData.map((msg) => (
                    <MessageBox key={msg._id} message={msg} />
                  ))}{" "}
              </div>
            </Col>
            <Col md={6} sm={12} className="">
              {/* Updates History Section */}
              <div className="compact-updates-history">
                <div className="compact-updates-header"> Updates History </div>
                {messageData &&
                  messageData.map((data, index) => (
                    <div className="compact-update text-center" key={index}>
                      <div className="compact-update-date text-center">
                        {new Date(data.updatesHistory.date).toLocaleDateString(
                          "en-GB"
                        ) +
                          " - " +
                          new Date(data.updatesHistory.date)
                            .toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace(":", ".")}
                      </div>

                      <div className="compact-update-user text-center">
                        {" "}
                        {data.updatesHistory.staff?.name}{" "}
                      </div>
                      <div
                        className={"compact-update-status text-center "}
                        style={{
                          color: data.colorCode ? data.colorCode : "#000000",
                        }}
                      >
                        {data.updatesHistory.status}
                      </div>
                    </div>
                  ))}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
}
